import { render, staticRenderFns } from "./result-module.vue?vue&type=template&id=321e33f4&scoped=true"
import script from "./result-module.vue?vue&type=script&lang=js"
export * from "./result-module.vue?vue&type=script&lang=js"
import style0 from "./result-module.vue?vue&type=style&index=0&id=321e33f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e33f4",
  null
  
)

export default component.exports